import { getDateTimeParts } from './get-date-time-parts.mjs';

function isSameYear(date1, date2, timeZone) {
  const {
    year: year1
  } = getDateTimeParts(date1, timeZone);
  const {
    year: year2
  } = getDateTimeParts(date2, timeZone);
  return year1() === year2();
}

export { isSameYear };
